{
    "coordinates": [
        41.539556369939054,
        121.2435756042538
    ],
    "tooltip": "Yixian",
    "title": "Yixian Formation",
    "country": "China",
    "period": "Cretaceous",
    "alt": "TODO"
}
